import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";

import { initHamburger, initMenuCurrent } from "./modules/_menu";
import { initReveal, markRevealReady } from "./modules/_reveal";
import { initSlideIn } from "./modules/_slideIn";
import { initSmoothScroll } from "./modules/_smoothScroll";
import { initTabs } from "./modules/utils";

// 初回描画前にフラグを立て、リビール要素が一瞬見えてしまうのを防ぐ
markRevealReady();

/** スクロール領域にカスタムスクロールバーを適用する */
const initScrollbars = () => {
  document.querySelectorAll(".js-simplebar").forEach((element) => {
    new SimpleBar(element, { autoHide: false });
  });
};

/** KVが画面から出たらハンバーガーボタンを表示する */
const initHamburgerVisibility = () => {
  const kv = document.querySelector(".kv");
  const hbgBtn = document.querySelector(".js-hbg");
  if (!kv || !hbgBtn) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        hbgBtn.classList.toggle("is-open", !entry.isIntersecting);
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    },
  );

  observer.observe(kv);
};

let isInitialized = false;

const initializePage = () => {
  if (isInitialized) return;
  isInitialized = true;

  initScrollbars();
  initSlideIn();
  initSmoothScroll();
  initHamburger();
  initMenuCurrent();
  initTabs();
  initHamburgerVisibility();
  initReveal();
};

// モジュールが DOMContentLoaded 後に評価された場合も初期化されるようにする
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializePage);
} else {
  initializePage();
}
